export const headerTranslation = {
  contact_us: 'Fale conosco',
  language: 'Idioma', // Texto do lado do ícone do languageMenu
  language_menu: {
    portuguese: 'Português',
    english: 'Inglês',
  },
};
